import React from 'react';
import { useParams } from 'react-router-dom';
import { Card, Descriptions, Tag, List, Typography } from 'antd';

const { Title } = Typography;

// Mock data for a specific task report
const reportData = {
  'task-xyz-123': {
    taskId: 'task-xyz-123',
    tenant: 'Customer Alpha',
    packageName: 'com.example.evilapp',
    sha256: 'a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2c3d4e5f6a1b2',
    submissionTime: '2025-11-10 14:55:00',
    status: 'Success',
    androidVersion: '12.0',
    triggeredRules: [
      { id: 'YARA-001', name: 'Detects common malware packing', type: 'YARA' },
      { id: 'CEL-005', name: 'Unauthorized network connection to C&C server', type: 'CEL' },
    ],
    networkActivity: [
      'DNS query for evil-server.com',
      'HTTP POST to http://evil-server.com/data-exfil',
      'Opens a socket to 123.45.67.89:6667',
    ],
    fileSystemActivity: [
      'Creates file /data/data/com.example.evilapp/stolen_data.txt',
      'Reads /sdcard/DCIM/Camera/IMG_20251110.jpg',
      'Deletes original APK file after execution',
    ],
  },
  // Add more mock reports as needed
};

const TaskReportPage = () => {
  const { taskId } = useParams<{ taskId: string }>();
  const report = (reportData as any)[taskId || ''];

  if (!report) {
    return <Title level={3}>Report for task {taskId} not found.</Title>;
  }

  return (
    <div>
      <Title level={2}>Analysis Report for Task: {taskId}</Title>
      <Card>
        <Descriptions bordered>
          <Descriptions.Item label="Task ID">{report.taskId}</Descriptions.Item>
          <Descriptions.Item label="Tenant">{report.tenant}</Descriptions.Item>
          <Descriptions.Item label="Status"><Tag color="green">{report.status}</Tag></Descriptions.Item>
          <Descriptions.Item label="Package Name">{report.packageName}</Descriptions.Item>
          <Descriptions.Item label="SHA256" span={2}>{report.sha256}</Descriptions.Item>
          <Descriptions.Item label="Submission Time">{report.submissionTime}</Descriptions.Item>
          <Descriptions.Item label="Android Version">{report.androidVersion}</Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title="Triggered Rules" style={{ marginTop: 16 }}>
        <List
          dataSource={report.triggeredRules}
          renderItem={(item: any) => (
            <List.Item>
              <List.Item.Meta
                title={`${item.name} (${item.id})`}
                description={`Type: ${item.type}`}
              />
            </List.Item>
          )}
        />
      </Card>

      <Card title="Network Activity" style={{ marginTop: 16 }}>
        <List
          dataSource={report.networkActivity}
          renderItem={(item: string) => <List.Item>{item}</List.Item>}
        />
      </Card>
      
      <Card title="File System Activity" style={{ marginTop: 16 }}>
        <List
          dataSource={report.fileSystemActivity}
          renderItem={(item: string) => <List.Item>{item}</List.Item>}
        />
      </Card>
    </div>
  );
};

export default TaskReportPage;
